import React, { PureComponent } from 'react';
import { object, string } from 'prop-types';
import styled, { css } from 'styled-components';
import { fontSize, fontFamily } from '../../../../constants/text';
import { colors } from '../../../../constants/colors';
import Collapse from '@material-ui/core/Collapse';
import { isEmptyArray } from '../../../../core/util/array';
import { INFO_FIELD_DEFAULT_STATE } from '../../../../constants/clinicDetailPage';
import { smallerThan } from '../../../../core/util/styledComponents';

const Root = styled.div`
  max-width: 400px;
`;

const Title = styled.h2`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  color: ${colors.link};
  cursor: pointer;
  display: flex;
  align-items: center;
  width: fit-content;
`;

const List = styled.ol`
  list-style: none;
  padding: 0;
`;

const Row = styled.li`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: ${colors.greyDim} 1px solid;
`;

const Item = styled.div`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  color: ${colors.blueMonday};
  text-align: left;
`;

const RightItem = styled(Item)`
  width: 60%;

  ${smallerThan.sm`
    width: 50%;
  `}
`;

const StyledChevron = styled.img`
  width: 12px;
  margin-left: 10px;

  ${({ expanded }) =>
    expanded &&
    css`
      transform: rotate(180deg);
    `}
`;

const Brand = styled.span`
  &:not(:last-child) {
    &::after {
      content: ', ';
    }
  }
`;

const Employee = styled.span`
  &:not(:last-child) {
    &::after {
      content: ', ';
    }
  }
`;

export default class AdditionalInfo extends PureComponent {
  static propTypes = {
    location: object.isRequired,
    className: string,
  };

  state = {
    expanded: false,
  };

  expandList = () => this.setState({ expanded: !this.state.expanded });

  render() {
    const { expanded } = this.state;
    const { yearOpened, ownership, hospitalAffiliations, providerNames } = this.props.location;

    if (
      !yearOpened &&
      !ownership &&
      isEmptyArray(hospitalAffiliations) &&
      isEmptyArray(providerNames)
    ) {
      return null;
    }

    return (
      <Root className={this.props.className}>
        <Title onClick={this.expandList}>
          Additional Info
          <StyledChevron
            src="/images/icons/drop_down_arrow_link_color.svg"
            expanded={expanded}
            alt="Open additional info"
          />
        </Title>
        <Collapse in={expanded}>
          <List>
            <Row>
              <Item>Year Open</Item>
              <RightItem itemProp={yearOpened ? 'foundingDate' : undefined}>
                {yearOpened || INFO_FIELD_DEFAULT_STATE}
              </RightItem>
            </Row>
            <Row>
              <Item>Ownership</Item>
              <RightItem itemProp={ownership ? 'ownershipFundingInfo' : undefined}>
                {ownership || INFO_FIELD_DEFAULT_STATE}
              </RightItem>
            </Row>
            <Row>
              <Item>Hospital Affiliation(s)</Item>
              <RightItem>
                {isEmptyArray(hospitalAffiliations)
                  ? INFO_FIELD_DEFAULT_STATE
                  : hospitalAffiliations.map(brand => <Brand itemProp="brand">{brand}</Brand>)}
              </RightItem>
            </Row>
            <Row>
              <Item>Provider Name(s)</Item>
              <RightItem>
                {isEmptyArray(providerNames)
                  ? INFO_FIELD_DEFAULT_STATE
                  : providerNames.map(employee => (
                      <Employee itemProp="employee">{employee}</Employee>
                    ))}
              </RightItem>
            </Row>
          </List>
        </Collapse>
      </Root>
    );
  }
}
